'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _language = require('../language');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Placeholder = function (_Component) {
    (0, _inherits3.default)(Placeholder, _Component);

    function Placeholder(props) {
        (0, _classCallCheck3.default)(this, Placeholder);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Placeholder.__proto__ || (0, _getPrototypeOf2.default)(Placeholder)).call(this, props));

        _this.state = {
            display: true
        };
        _this.dataTestID = 'placeholder';
        return _this;
    }

    (0, _createClass3.default)(Placeholder, [{
        key: 'hidden',
        value: function hidden() {
            this.setState({ display: false });
        }
    }, {
        key: 'show',
        value: function show() {
            this.setState({ display: true });
        }
    }, {
        key: 'getDataTestId',
        value: function getDataTestId() {
            var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'component';

            return this.props.dataTestID || this.dataTestID + '-' + prefix;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                placeholder = _props.placeholder,
                visibleIcon = _props.visibleIcon,
                iconAlign = _props.iconAlign,
                value = _props.value,
                type = _props.type,
                separator = _props.separator,
                style = _props.style;
            var display = this.state.display;

            if (!display) {
                return null;
            }
            if (type === 'range') {
                var placeholderFrom = "";
                var placeholderTo = "";
                if (!_lodash2.default.isEmpty(value)) {
                    return null;
                }
                if (_lodash2.default.isObject(value)) {
                    if (!_lodash2.default.get(value, 'fromDate')) {
                        placeholderFrom = placeholder[0];
                    }
                    if (!_lodash2.default.get(value, 'toDate')) {
                        placeholderTo = placeholder[1];
                    }
                } else {
                    if (!_lodash2.default.get(value, '0')) {
                        placeholderFrom = placeholder[0];
                    }
                    if (!_lodash2.default.get(value, '1')) {
                        placeholderTo = placeholder[1];
                    }
                }
                return _react2.default.createElement(
                    'div',
                    {
                        className: 'placeholder',
                        style: {
                            right: visibleIcon && iconAlign === 'after' ? 35 : 0,
                            left: visibleIcon && iconAlign === 'before' ? 35 : 0,
                            display: 'flex'
                        }
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'placeholder-first', style: { flex: 1, paddingLeft: 9 } },
                        placeholderFrom && _react2.default.createElement(
                            'span',
                            { className: 'placeholder-text' },
                            _react2.default.createElement(_language.TextTranslate, { text: placeholderFrom })
                        )
                    ),
                    _react2.default.createElement('div', { style: { width: separator || 10 } }),
                    _react2.default.createElement(
                        'div',
                        { className: 'placeholder-second', style: { flex: 1 } },
                        placeholderTo && _react2.default.createElement(
                            'span',
                            { className: 'placeholder-text' },
                            _react2.default.createElement(_language.TextTranslate, { text: placeholderTo })
                        )
                    )
                );
            }

            if (value === undefined || value === null || value === "" || _lodash2.default.isObject(value) && _lodash2.default.isEmpty(value)) {
                return _react2.default.createElement(
                    'div',
                    {
                        'data-testid': this.getDataTestId(),
                        className: 'placeholder',
                        style: (0, _assign2.default)({
                            right: visibleIcon && iconAlign === 'after' ? 35 : 0,
                            left: visibleIcon && iconAlign === 'before' ? 35 : 0
                        }, style)
                    },
                    _react2.default.createElement(
                        'span',
                        { className: 'placeholder-text' },
                        _react2.default.isValidElement(placeholder) ? placeholder : _react2.default.createElement(_language.TextTranslate, { text: placeholder })
                    )
                );
            }
            return null;
        }
    }]);
    return Placeholder;
}(_react.Component);

exports.default = Placeholder;